
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class RisorseChecklistDialog extends Serenity.EntityDialog<RisorseChecklistRow, any> {
        protected getFormKey() { return RisorseChecklistForm.formKey; }
        protected getIdProperty() { return RisorseChecklistRow.idProperty; }
        protected getLocalTextPrefix() { return RisorseChecklistRow.localTextPrefix; }
        protected getService() { return RisorseChecklistService.baseUrl; }
        protected getDeletePermission() { return RisorseChecklistRow.deletePermission; }
        protected getInsertPermission() { return RisorseChecklistRow.insertPermission; }
        protected getUpdatePermission() { return RisorseChecklistRow.updatePermission; }

        protected form = new RisorseChecklistForm(this.idPrefix);

    }
}